import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { translateFieldError } from '../../types';
import translate from '../../utils/utils';
const SinInput = forwardRef(({ id, reason, error, mandatory, ...otherProps }, ref) => {
    const { t } = useTranslation('shared');
    const errorMessage = translateFieldError(t, error);
    return (_jsxs("div", { className: `control-group  ${error && 'error'}`, children: [reason && _jsx("p", { children: translate(reason) }), _jsx("label", { htmlFor: id, children: t(mandatory ? 'personalInformation.mandatorySin' : 'personalInformation.sin') }), _jsx("input", { ref: ref, id: id, placeholder: "XXX XXX XXX", className: "sin-input", type: "text", inputMode: "numeric", ...otherProps, maxLength: 11 }), error && _jsx("p", { className: "error-message", children: errorMessage })] }));
});
SinInput.displayName = 'SinInput';
export default SinInput;
